import { useEffect, useRef } from 'react'

const useEditorDisabled = disabled => {
  const editorRef = useRef(null)

  useEffect(() => {
    if (!editorRef.current) return
    if (disabled) {
      editorRef.current.disable()
    } else {
      editorRef.current.enable()
    }
  }, [disabled])

  return editorRef
}

export default useEditorDisabled
